import { FormLabel } from "@mui/material";
import React from "react";
import { customColor } from "../styles/customColor";

function WalkInFormLabel({ labelName }) {
  return (
    <FormLabel sx={{ gap: "5px" }}>
      <p
        style={{
          fontFamily: "Poppins-Light",
          fontWeight: "bold",
          margin: 0,
          color: customColor.tertiary,
        }}
      >
        {labelName}
        <span style={{ color: "#CB1212", marginLeft: "5px" }}>*</span>
      </p>
    </FormLabel>
  );
}

export default WalkInFormLabel;
